import { createContext, use } from "react";
import type {
  BoligTypePrivat,
  BoligTypeSelskap,
  PostAvtaleSelskapRequest,
} from "@/api/generated";

export type BestillingAktoerPrivat = {
  type: "Privat";
};

export type BestillingAktoerSelskap = {
  type: "Selskap";
  organisasjonsnummer: number;
};
export type BestillingAktoer = BestillingAktoerSelskap | BestillingAktoerPrivat;

export type BestillerPrivatCheck = PostAvtaleSelskapRequest;

export type BestillerPrivat = {
  boligType: BoligTypePrivat;
  kundenummer: string;
  målerId?: string;
  adresse: string;
  postNummer: number;
  sted: string;
};

export type BestillerSelskap = {
  kundenummer: string;
  målerId?: string;
  antallBoenheter: number;
  næringsdrivende: boolean;
  næringsarealProsent?: number | null | undefined;
  boligType: BoligTypeSelskap | undefined;
};

export type BestillingPeriode = {
  fromInclusive: string;
  toExclusive: string;
};

export type BestillingContextDataType = {
  leverandoerOrgNr: string | null;
  aktoer: BestillingAktoer | null;
  avtalePeriode: BestillingPeriode | null;
  bestillerPrivat: BestillerPrivat | null;
  bestillerSelskap: BestillerSelskap | null;
  vilkårAkseptert: boolean | null;
};

export type BestillingContextType = {
  bestilling: BestillingContextDataType;
  setBestillingData: (setBestillingData: BestillingContextDataType) => void;
  resetBestillingData: () => void;
  readOnly: boolean;
};

export const BestillingContext = createContext<BestillingContextType>(
  {} as BestillingContextType,
);

export const useBestillingContext = () => use(BestillingContext);
